<template>
    <div class="file-preview-container">
        <div class="file-preview-content">
            <div class="file-preview-hearder-content">
                <div class="file-preview-header-left">
                        <div class="svg-wrapper" v-html="determineSvgIconForType('path')">
                            <!--<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M13.6 40.9c3.8 0 7-1.3 9.7-4 2.7-2.7 4-5.9 4-9.7 0-3.8-1.3-7-4-9.7-2.7-2.7-5.9-4-9.7-4-3.8 0-7 1.3-9.7 4-2.7 2.7-4 5.9-4 9.7 0 3.8 1.3 7 4 9.7 2.7 2.7 5.9 4 9.7 4zm20.5 20.5L22.7 50 0 72.7v13.6h100V54.5L70.5 25 34.1 61.4z" fill="#e89131"/></svg> -->
                        </div>
                        <div class="filename-wrapper">
                            {{assetInfo.file_name}}
                        </div>
                    
                </div>
                <div class="file-preview-header-right">
                    <div class="more-options">
                        <div class="icon-hover" v-if="isPrivilegeEnabled('Download') && assetInfo.asset_state != 'MARK FOR DELETE'" v-html="getDownloadSvg()" style="margin-inline-end: 17px;" @click="submitDownloadJob" title="Download file"></div>
                        <!-- <div class="icon-hover"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg></div> -->
                    </div>

                    <div class="user-name-or-image user-name" :style="style()">{{ getUserName() }}</div>
                    <!--
                    <div class="authentication-logo">
                        E
                    </div> -->
                </div>
            </div>
            <!-- preview area -->

              <ImageFilePreview v-if="previewTypeInfo.image" :url="url"/>
              <VideoFilePreview v-if="previewTypeInfo.video" :url="url"/>
              <AudioFilePreview v-if="previewTypeInfo.audio" :url="url" :backgroundUrl="getUtils().getThumbnailPathfromFileInfo(assetInfo)"/>
              <OtherFilePreview v-if="previewTypeInfo.other" :url="url" :backgroundUrl="getUtils().getThumbnailPathfromFileInfo(assetInfo)" :asetsInfo="assetInfo" v-on:triggerfileDownload="submitDownloadJob()"/>
 
            <!-- end of preview area -->
        </div>
    </div>
</template>

<script>
import ImageFilePreview from './imagefilePreview.vue';
import VideoFilePreview from './videoFilePreview.vue'; 
import AudioFilePreview from './audioFilePreview.vue';
import OtherFilePreview from './otherFilePreview.vue';
import Utils from "../../components.utils.js";
import {mapGetters} from "vuex";

export default {
  name:'FilePreview',
  components:{
      ImageFilePreview,
      VideoFilePreview,
      AudioFilePreview,
      OtherFilePreview
  },
  data(){
      return {
          url:'',
          previewTypeInfo:{image:false,video:false,audio:false,other:false},
          assetInfo:{},
      }
  },
  methods:{
      isPrivilegeEnabled(priv){
        return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(), priv)
      },
      getFileMimeType(fileObj){
         let supportedMimeType = ['audio','video','image','other'];
         for(let i = 0; i < supportedMimeType.length; i++){
             if(Utils.getFileMediaType(fileObj).startsWith(supportedMimeType[i])) return supportedMimeType[i];
         }
         return 'other';
      },
      determineSvgIconForType(type){
          console.log("this.url",this.url);
          return Utils.determineSvgIconForType(this.assetInfo, type);
      },

      getDownloadSvg(){
          return Utils.getDownloadSvg();
      },

    submitDownloadJob() {
      let payload = {};
      payload.bin_id = this.assetInfo.bin_id;
      payload.element_type = "file";
      payload.job_name = "Download";
      payload.file_name = this.assetInfo.file_name;
      payload.path = this.assetInfo.path;
      let fileMimeType = this.assetInfo.mime_type;
      let fileName = this.assetInfo.file_name;
      this.$toast.success('Initiate Download request submitted.');
      this.$store.dispatch('download/initiateDownloadJob',payload).then((data) => {
        let jobIdFromResponse = data.job_id;
        let payload = {};
        payload = { job_id: "job_id=" + jobIdFromResponse };
        this.$store.dispatch('download/downloadFile',payload).then((data) => {
          const blob = new Blob([data], {
            type: fileMimeType,
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          URL.revokeObjectURL(link.href);
        });
        if (Utils.isAcceptedStatusCode(data.statusCode) == 200) {
          console.log("Download initiated");
        } else {
          this.$toast.error(data.message);
        }
      });
    },
    style(){
      let user = JSON.parse(Utils.getLocalStorageValue("userInfo"));
      let style = {
        'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(user.username))),
        'background-color':'#'+Utils.intToRGB(Utils.hashCode(user.username))
      }
      return style
    },
    getUserName(){
      let user = JSON.parse(Utils.getLocalStorageValue("userInfo"));
        return user.username.split("")[0];
    },
    getUtils(){
      return Utils;
    },
    ...mapGetters("users",["getLoggedInUserPrivilege"]),
  },
  async mounted(){
      let url = window.location.href;
      let pattern = /((\/assets)\/([a-zA-Z0-9]+)\/(view))/;
      if(url){
          let resultList = pattern.exec(url), assetId = null;
          if(resultList.length >= 3) assetId = resultList[3];
          let assetInfo = await this.$store.dispatch('assets/getAssetInfoFromServer',{params:{assetId:assetId}});

          this.assetInfo = assetInfo.asset;
          let type = this.getFileMimeType(assetInfo.asset);
          this.previewTypeInfo[type] = true;
          if(type == 'image'){
            this.url =  Utils.getThumbnailPathfromFileInfo(assetInfo.asset);            
          }
          if(type == 'audio'){
              this.url = Utils.getAudiowaveformFromFileInfo(assetInfo.asset);
          }
          if(type == 'video'){
             this.url = Utils.getLowresPathfromFileInfo(assetInfo.asset);
          }
          if(['image','video','audio'].indexOf(type) == -1){
              this.url =  Utils.getPDFPATHFromFileInfo(assetInfo.asset);
          }
      }
  }
}
</script>

<style lang="scss">
  $border-color: 1px solid #3a3a3a;
   .file-preview-content{
       display: flex;
        width: 100vw;
        height: 100vh;
        flex-direction: column;
        background: #262626;
   }
   .file-preview-hearder-content{
        height: 10%;
        display: flex;
        justify-content: space-between;
        /* margin: 19px 32px; */
        padding-top: 8px;
        margin-inline-end: 12px;
        padding-inline-start: 23px;
        z-index: 999999999999999;
   }
   .file-preview-image-container{
       height: 100%;
   }
   .file-preview-header-left{
        display: flex;
        justify-content: center;
        align-items: center;
        .svg-wrapper{
           width: 40px;
           height: 40px;
        }
        .filename-wrapper{
            margin-inline-start: 15px;
            margin-top: 8px;
        }
   }

   .file-preview-header-right{
          display: flex;
          align-items: center;
          margin-inline-end: 17px;
          .authentication-logo{
            display: flex;
            width: 39px;
            height: 39px;
            background: rebeccapurple;
            text-align: center;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            font-size: 18px;
            cursor: pointer;
      }
      .more-options{
          // margin-inline-end: 30px;
          display: flex;
      }
   }

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    //margin-top: 3px;
    position: relative;
    top: -3px;
}

.icon-hover{
   width: 40px;
   height: 40px;
   display: flex;
   justify-content: center;
   align-items: center;
}

.icon-hover:hover{
  border-radius: 20px;
  background: #222;
  filter: brightness(160%);
}

.svgicon svg{
   width: 100%;
   height: 100%;
}

.svg-wrapper svg{
   min-width: 34px;
   min-height: 34px;
}

// .user-name{
//     margin-inline-end: 10px;
//     position: relative;
//     bottom: 7px;
// }

::-webkit-scrollbar {
  width: 0;
  height: 0;
}
</style>